import { Link, Paragraph } from '@vimeo/iris/typography';

export default function ApiApps() {
  return (
    <div>
      <Paragraph size="2">
        For more information about API apps, see our{' '}
        <Link variant="minimal" href="https://developer.vimeo.com/api/guides/start">
          Getting Started: The Basics
        </Link>{' '}
        guide.
      </Paragraph>

      <Paragraph size="2">Use the API to complete the following tasks:</Paragraph>
    </div>
  );
}
